import {
  SUBSCRIPTION_PLAN_REQUEST,
  SUBSCRIPTION_PLAN_SUCCESS,
  SUBSCRIPTION_PLAN_FAILURE,

  ///Term & Condition /Privacy Policy /Refund Policy
  TERMS_REQUEST,
  TERMS_SUCCESS,
  TERMS_FAILURE,
  PRIVACY_REQUEST,
  PRIVACY_SUCCESS,
  PRIVACY_FAILURE,
  REFUND_REQUEST,
  REFUND_SUCCESS,
  REFUND_FAILURE,

  //PKINDEV_COMPANY DATA  70
  PKINDEV_RESQUEST,
  PKINDEV_RESPOND,

  //PROJECT
  PROJECT_RESQUEST,
  PROJECT_RESPOND,

  //PROJECT PLAN
  PROJECT_PLAN_REQUEST,
  PROJECT_PLAN_RESPOND,
} from "../actions";

const INIT_STATE = {
  // subscriptionData: [],
  subscriptionPlanData: [],
  projectPlan: [],

  ///Term & Condition /Privacy Policy /Refund Policy
  terms: null,
  privacy: null,
  refund: null,

  loading: false,
  error: null,

  //project
  project: [],
  //pkindev
  pkindev: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    //PROJECT
    case PROJECT_RESQUEST:
      return { ...state, loading: true };
    case PROJECT_RESPOND:
      return {
        ...state,
        loading: false,
        project: action.payload,
        error: action.payload?.error || null,
      };

    //PROJECT PLAN
    case PROJECT_PLAN_REQUEST:
      return { ...state, loading: true };
    case PROJECT_PLAN_RESPOND:
      return {
        ...state,
        loading: false,
        projectPlan: action.payload,
        error: action.payload?.error || null,
      };

    //PKINDEV
    case PKINDEV_RESQUEST:
      return { ...state, loading: true };
    case PKINDEV_RESPOND:
      return {
        ...state,
        loading: false,
        pkindev: action.payload?.data || null,
        error: action.payload?.error || null,
      };

    //PROJECT

    //-----------------ดึงข้อมูล SubscriptionPlan จาก id_subscription_plan_table

    case SUBSCRIPTION_PLAN_REQUEST:
      return { ...state, loading: true };

    case SUBSCRIPTION_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        subscriptionPlanData: action.payload,
      };

    case SUBSCRIPTION_PLAN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    ///Term & Condition /Privacy Policy /Refund Policy
    //TERM
    case TERMS_REQUEST:
      return { ...state, loading: true };
    case TERMS_SUCCESS:
      return { ...state, loading: false, terms: action.payload };
    case TERMS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    //PRIVACY
    case PRIVACY_REQUEST:
      return { ...state, loading: true };
    case PRIVACY_SUCCESS:
      return { ...state, loading: false, privacy: action.payload };
    case PRIVACY_FAILURE:
      return { ...state, loading: false, error: action.payload };
    //REFUND
    case REFUND_REQUEST:
      return { ...state, loading: true };
    case REFUND_SUCCESS:
      return { ...state, loading: false, refund: action.payload };
    case REFUND_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
